export default __webpack_public_path__ + "static/media/opera-logo.344ddd86.svg";